import React, { useReducer, useContext } from 'react';
import firebase from 'firebase';

import { firestoreInitialize } from 'config/firebase/client';

import ProductsContext from './ProductsContext';
import ProductsReducer from './ProductsReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const ProductsState = (props) => {
    const initialState = {
        getProducts: {
            products: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getProductsTypes: {
            productsTypes: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createProducts: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getCategoriesProducts: {
            categoriesProducts: [],
            firstCategoryProduct: null,
            lastCategoryProduct: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getCategoriesProductsById: {
            categoryProduct: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createCategoriesProducts: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateCategoriesProductsById: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getSubCategoriesProductsById: {
            subCategoriesProducts: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createSubCategoriesProducts: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
    };

    const [state, dispatch] = useReducer(ProductsReducer, initialState);

    const { authenticatedState } = useContext(AuthenticationContext);

    const getProducts = () => {
        dispatch({ type: 'GET_PRODUCTS_LOADING' });

        let db = firestoreInitialize();

        db.collectionGroup('CategoriasProductos')
            .get()
            .then((querySnapshot) => {
                let data;

                querySnapshot.forEach((document) => {
                    document.ref.collection("Productos").where("categoriaProductoId", "!=", "").get().then((querySnapshot) => {
                        if (data) {
                            data = data.concat(querySnapshot.docs.map(doc => doc.data()))
                        } else {
                            data = querySnapshot.docs.map(doc => doc.data())
                        }
                        dispatch({ type: 'GET_PRODUCTS', payload: { data: data } })
                    })
                })
            })
            .catch((error) => dispatch({ type: 'GET_PRODUCTS_ERROR', payload: { code: 'services/error', message: error } }))
    };

    const getProductsTypes = () => {
        dispatch({ type: 'GET_PRODUCTS_TYPES_LOADING' });

        let db = firestoreInitialize();

        db.collection('tipoProductos')
            .get()
            .then((documentSnapshots) => {
                dispatch({ type: 'GET_PRODUCTS_TYPES', payload: { data: documentSnapshots.docs.map(doc => doc.id) } });
            })
            .catch((error) => dispatch({ type: 'GET_PRODUCTS_TYPES_ERROR', payload: { code: 'services/error', message: error } }))
    };

    const createProducts = (data) => {
        dispatch({ type: 'CREATE_PRODUCTS_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'CREATE_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collection('CategoriasProductos').doc(data.categorySelect)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.ref.collection("Productos").add({
                            categoriaProductoId: data.categorySelect,
                            nombre: data.name,
                            status: data.status,
                            imagen: downloadURL
                        }).then((doc) => {
                            querySnapshot.ref.collection("Productos").doc(doc.id).update({
                                productoId: doc.id
                            }).then(() => {
                                dispatch({ type: 'CREATE_PRODUCTS', payload: { data: data } })
                            })
                        })
                    })
                    .catch((error) => dispatch({ type: 'CREATE_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))
                });
            });
        } else {
            db.collection('CategoriasProductos').doc(data.categorySelect)
            .get()
            .then((querySnapshot) => {
                querySnapshot.ref.collection("Productos").add({
                    categoriaProductoId: data.categorySelect,
                    nombre: data.name,
                    status: data.status,
                    imagen: ""
                }).then((doc) => {
                    querySnapshot.ref.collection("Productos").doc(doc.id).update({
                        productoId: doc.id
                    }).then(() => {
                        dispatch({ type: 'CREATE_PRODUCTS', payload: { data: data } })
                    })
                })
            })
            .catch((error) => dispatch({ type: 'CREATE_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))
        }
    };

    const getCategoriesProducts = (nextPage, prevPage) => {
        dispatch({ type: 'GET_CATEGORIES_PRODUCTS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador") {
            getGlobalCategoriesProducts(nextPage, prevPage);
        } else {
            getCategoriesProductsPerCountry(nextPage, prevPage, authenticatedState.user.pais);
        }
    };

    const getGlobalCategoriesProducts = (nextPage, prevPage) => {
        let db = firestoreInitialize();

        if (nextPage) {
            db.collection('CategoriasProductos')
            .where('categoriaProductoId', '==', nextPage)
            .get()
            .then((querySnapshot) => {
                const dataAfter = querySnapshot.docs[0];

                let first = db.collection("CategoriasProductos")
                .where("categoriaPadreId", "==", "")
                .startAfter(dataAfter)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CATEGORIES_PRODUCTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))
        } else if (prevPage) {
            db.collection('CategoriasProductos')
            .where('categoriaProductoId', '==', prevPage)
            .get()
            .then((querySnapshot) => {
                const dataBefore = querySnapshot.docs[0];

                let first = db.collection("CategoriasProductos")
                .where("categoriaPadreId", "==", "")
                .endBefore(dataBefore)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CATEGORIES_PRODUCTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))
        } else {
            let first = db.collection("CategoriasProductos")
                .where("categoriaPadreId", "==", "")
                .limit(10)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_CATEGORIES_PRODUCTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
            })
            .catch(error => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))   
        }
    };

    const getCategoriesProductsPerCountry = (nextPage, prevPage, country) => {
        let db = firestoreInitialize();

        if (nextPage) {
            db.collection('CategoriasProductos')
            .where('categoriaProductoId', '==', nextPage)
            .get()
            .then((querySnapshot) => {
                const dataAfter = querySnapshot.docs[0];

                let first = db.collection("CategoriasProductos")
                .where("categoriaPadreId", "==", "")
                .where("pais", "==", country)
                .startAfter(dataAfter)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CATEGORIES_PRODUCTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))
        } else if (prevPage) {
            db.collection('CategoriasProductos')
            .where('categoriaProductoId', '==', prevPage)
            .get()
            .then((querySnapshot) => {
                const dataBefore = querySnapshot.docs[0];

                let first = db.collection("CategoriasProductos")
                .where("categoriaPadreId", "==", "")
                .where("pais", "==", country)
                .endBefore(dataBefore)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CATEGORIES_PRODUCTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))
        } else {
            let first = db.collection("CategoriasProductos")
                .where("categoriaPadreId", "==", "")
                .where("pais", "==", country)
                .limit(10)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_CATEGORIES_PRODUCTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
            })
            .catch(error => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } }))   
        }
    }

    const getCategoriesProductsById = (id) => {
        dispatch({ type: 'GET_CATEGORIES_PRODUCTS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        db.collectionGroup('CategoriasProductos')
            .where('categoriaProductoId', '==', id)
            .get()
            .then((querySnapshot) => {
                dispatch({ type: 'GET_CATEGORIES_PRODUCTS_BY_ID', payload: { data: querySnapshot.docs.map(doc => doc.data()) } })
            })
            .catch((error) => dispatch({ type: 'GET_CATEGORIES_PRODUCTS_BY_ID_ERROR', payload: { code: 'products/error', message: error } }))
    };

    const createCategoriesProducts = (data) => {
        dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collection("CategoriasProductos").add({
                        categoriaPadreId: "",
                        categoriaProductoId: "",
                        categoriaRaizId: "",
                        imagen: downloadURL,
                        nivel: 1,
                        nombre: data.name,
                        status: data.status
                    })
                    .then((docRef) => {
                        let docCategory = db.collection("CategoriasProductos").doc(docRef.id);
            
                        docCategory.update({
                            categoriaProductoId: docRef.id
                        })
                        .then(() => {
                            dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS' })
                        })
                        .catch((error) => {
                            dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
                        });
                    }).catch((error) => {
                        dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
                    });
                });
            });
        } else {
            db.collection("CategoriasProductos").add({
                categoriaPadreId: "",
                categoriaProductoId: "",
                categoriaRaizId: "",
                imagen: "",
                nivel: 1,
                nombre: data.name,
                status: data.status
            })
            .then((docRef) => {
                let docCategory = db.collection("CategoriasProductos").doc(docRef.id);
    
                docCategory.update({
                    categoriaProductoId: docRef.id
                })
                .then(() => {
                    dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS' })
                })
                .catch((error) => {
                    dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
                });
            }).catch((error) => {
                dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
            });
        }
    };

    const updateCategoriesProductsById = (id, data) => {
        dispatch({ type: 'UPDATE_CATEGORIES_PRODUCTS_BY_ID_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        let docRef = db.collection("CategoriasProductos").doc(id);

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'UPDATE_CATEGORIES_PRODUCTS_BY_ID_ERROR', payload: { code: 'product/update-error', message: error } });
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    docRef.update({
                        nombre: data.name,
                        status: data.status,
                        imagen: downloadURL
                    })
                    .then(() => {
                        dispatch({ type: 'UPDATE_CATEGORIES_PRODUCTS_BY_ID' });
                    })
                    .catch((error) => {
                        dispatch({ type: 'UPDATE_CATEGORIES_PRODUCTS_BY_ID_ERROR', payload: { code: 'product/update-error', message: error } });
                    });
                });
            });
        } else {
            if (data.deleteImage && data.imagePath.length > 0) {
                let storageRef = storage.refFromURL(data.imagePath);

                storageRef.delete().then(function() {
                    docRef.update({
                        nombre: data.name,
                        status: data.status,
                        imagen: ""
                    })
                    .then(() => {
                        dispatch({ type: 'UPDATE_CATEGORIES_PRODUCTS_BY_ID' });
                    })
                    .catch((error) => {
                        dispatch({ type: 'UPDATE_CATEGORIES_PRODUCTS_BY_ID_ERROR', payload: { code: 'product/update-error', message: error } });
                    });
                }).catch(function(error) {
                    console.log(error)
                    dispatch({ type: 'UPDATE_CATEGORIES_PRODUCTS_BY_ID_ERROR', payload: { code: 'product/update-error', message: error } });
                });
            } else {
                docRef.update({
                    nombre: data.name,
                    status: data.status
                })
                .then(() => {
                    dispatch({ type: 'UPDATE_CATEGORIES_PRODUCTS_BY_ID' });
                })
                .catch((error) => {
                    dispatch({ type: 'UPDATE_CATEGORIES_PRODUCTS_BY_ID_ERROR', payload: { code: 'product/update-error', message: error } });
                });
            }
        }
    };

    const createCategoriesWithExcel = async (data) => {
        dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS_LOADING' });

        let db = firebase.firestore();

        await data.forEach((doc) => {
            let parentId = '';

            db.collection("CategoriasProductos").add({
                categoriaPadreId: "",
                categoriaProductoId: "",
                categoriaRaizId: "",
                imagen: "",
                nivel: 1,
                nombre: doc.category,
                status: 'Active'
            }).then((docRef) => {
                parentId = docRef.id;

                db.collection("CategoriasProductos").doc(docRef.id).update({
                    categoriaProductoId: docRef.id,
                }).then(() => {
                    doc.subCategories.forEach((subCategory) => {
                        db.collection("CategoriasProductos").add({
                            categoriaPadreId: parentId,
                            categoriaProductoId: "",
                            categoriaRaizId: parentId,
                            imagen: "",
                            nivel: 1,
                            nombre: subCategory,
                            status: 'Active'
                        }).then((docRef) => {
                            db.collection("CategoriasProductos").doc(docRef.id).update({
                                categoriaProductoId: docRef.id,
                            });
                        }); 
                    });
                });
            });
        });

        dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS' });
    };

    const createCategoriesProductsResetState = () => {
        dispatch({ type: 'CREATE_CATEGORIES_PRODUCTS_RESET_STATE' });
    };

    const getSubCategoriesProductsById = (id) => {
        dispatch({ type: 'GET_SUBCATEGORIES_PRODUCTS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        db.collectionGroup('CategoriasProductos')
            .where('categoriaPadreId', '==', id)
            .get()
            .then((querySnapshot) => {
                dispatch({ type: 'GET_SUBCATEGORIES_PRODUCTS_BY_ID', payload: { data: querySnapshot.docs.map(doc => doc.data()) } })
            })
            .catch((error) => dispatch({ type: 'GET_SUBCATEGORIES_PRODUCTS_BY_ID_ERROR', payload: { code: 'products/error', message: error } }))
    };

    const createSubCategoriesProducts = (data) => {
        dispatch({ type: 'CREATE_SUBCATEGORIES_PRODUCTS_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'CREATE_SUBCATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collection("CategoriasProductos").add({
                        categoriaPadreId: data.categorySelect,
                        categoriaProductoId: "",
                        categoriaRaizId: data.categorySelect,
                        imagen: downloadURL,
                        nivel: 2,
                        nombre: data.name,
                        status: data.status
                    })
                    .then((docRef) => {
                        let docCategory = db.collection("CategoriasProductos").doc(docRef.id);
            
                        docCategory.update({
                            categoriaProductoId: docRef.id
                        })
                        .then(() => {
                            dispatch({ type: 'CREATE_SUBCATEGORIES_PRODUCTS' })
                        })
                        .catch((error) => {
                            dispatch({ type: 'CREATE_SUBCATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
                        });
                    }).catch((error) => {
                        dispatch({ type: 'CREATE_SUBCATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
                    });
                });
            });
        } else {
            db.collection("CategoriasProductos").add({
                categoriaPadreId: data.categorySelect,
                categoriaProductoId: "",
                categoriaRaizId: data.categorySelect,
                imagen: "",
                nivel: 2,
                nombre: data.name,
                status: data.status
            })
            .then((docRef) => {
                let docCategory = db.collection("CategoriasProductos").doc(docRef.id);
    
                docCategory.update({
                    categoriaProductoId: docRef.id
                })
                .then(() => {
                    dispatch({ type: 'CREATE_SUBCATEGORIES_PRODUCTS' })
                })
                .catch((error) => {
                    dispatch({ type: 'CREATE_SUBCATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
                });
            }).catch((error) => {
                dispatch({ type: 'CREATE_SUBCATEGORIES_PRODUCTS_ERROR', payload: { code: 'products/error', message: error } })
            });
        }
    };

    const getProductsByAlly = (ally) => {
        dispatch({ type: "GET_PRODUCTS_LOADING" })

        let db = firestoreInitialize();

        db.collection('Productos')
            .where("aliadoId", "==", ally)
            .get()
            .then((querySnapshot) => dispatch({ type: 'GET_PRODUCTS', payload: { data: querySnapshot.docs.map(doc => doc.data()) } }))
            .catch((error) => dispatch({ type: 'GET_PRODUCTS_ERROR', payload: { code: "products/error", message: error } }))
    };

    const updateResetCategoriesProducts = () => {
        dispatch({ type: 'UPDATE_CATEGORIES_PRODUCTS_RESET_STATE' });
    };

    return (
        <ProductsContext.Provider value={{
            productsState: state.getProducts,
            productsTypesState: state.getProductsTypes,
            createProductsState: state.createProducts,
            categoriesProductsState: state.getCategoriesProducts,
            categoryProductByIdState: state.getCategoriesProductsById,
            createCategoriesProductsState: state.createCategoriesProducts,
            updateCategoriesProductsByIdState: state.updateCategoriesProductsById,
            subCategoriesProductsByIdState: state.getSubCategoriesProductsById,
            createSubCategoriesProductsState: state.createSubCategoriesProducts,
            getProducts,
            getProductsTypes,
            createProducts,
            getCategoriesProducts,
            getCategoriesProductsById,
            createCategoriesProducts,
            createCategoriesProductsResetState,
            updateCategoriesProductsById,
            getSubCategoriesProductsById,
            createSubCategoriesProducts,
            createCategoriesWithExcel,
            getProductsByAlly,
            updateResetCategoriesProducts,
        }}>
            {props.children}
        </ProductsContext.Provider>
    )
}

export default ProductsState;
